import React from 'react';
import sanitizeHtml from 'sanitize-html';

const sanitizeAndRenderHtml = (
  content: string | undefined
): { __html: string } | undefined => {
  if (!content) return undefined;

  const sanitized = sanitizeHtml(content, {
    allowedAttributes: {
      span: ['class'],
    },
    allowedClasses: {
      span: ['*'], // Allow all classes on span elements
    },
    allowedTags: ['b', 'strong', 'i', 'em', 'u', 'span', 'br', 'p'],
  });

  return { __html: sanitized };
};

interface FeaturesListProps {
  features?: Array<{
    title: string;
    description: string;
  }>;
}

const FeaturesList = ({
  features = [
    {
      description: 'Get results in just minutes, no lab required.',
      title: 'Rapid Results',
    },
    {
      description:
        "Step-by-step instructions so simple you could do it half-asleep after a night out (but don't ask us if we've tested that theory).",
      title: 'Easy to Use',
    },
    {
      description:
        "Discrete packaging that won't raise eyebrows, and confidential results that stay your business.",
      title: '100% Private',
    },
  ],
}: FeaturesListProps) => {
  return (
    <div className="flex w-full flex-col pl-8 text-black md:w-[40%]">
      <ul
        className="flex list-outside flex-col gap-6"
        style={{ listStyleImage: "url('/double-checkmark.svg')" }}
      >
        {features.map((feature, index) => (
          <li key={index}>
            <div>
              <h3
                className="mb-3 font-['Spectral'] text-2xl leading-10 font-semibold tracking-[-5%]"
                dangerouslySetInnerHTML={sanitizeAndRenderHtml(feature.title)}
              />
              <span
                className="font-['Work_Sans'] text-base leading-5 font-normal"
                dangerouslySetInnerHTML={sanitizeAndRenderHtml(
                  feature.description
                )}
              />
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default FeaturesList;
